import CONFIGS from "../configs";

// Step 1: Choose your Device Data Collection Option
export async function callDataExchange(cardNumber,merchantId) {
    try {
        let cardNo = cardNumber.replace(/\s+/g, '');
        let isMerchantId = merchantId.replace(/\s+/g, '');
        
        const postData = {
            accountNumber: cardNo,
            merchantId: isMerchantId
        };

        const response = await fetch(`${CONFIGS.API.THREED_SECURE_CARDINAL_SERVICE}/cardinal/data-exchange`,{
            method: "POST",
            headers: { 
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(postData)
        });
        const data = await response.json();

        let html = `<form id="collectionForm" target="iframeJWTFrm" name="devicedata" method="POST" action="${CONFIGS.API.CARDINAL_SERVICE}/centinelapi/V2/Cruise/Collect">` +
        '<input type="hidden" name="JWT" value="' + data.token + '"/> </form>';
        
        const existingForm = document.getElementById('collectionForm');
        if (existingForm) {
            existingForm.remove();
        }

        //add html end of html code
        document.body.insertAdjacentHTML('beforeend', html);

        //submit token collection form:
        document.getElementById('collectionForm').submit();
        
    } catch (error) {
        throw error;
    }
}


// Step 2: Start Consumer Authentication with Lookup Request
export async function sendCmpiLookupRequest(requestData,onOpenModal) {
    try {
        const postData = {
            orderNumber: crypto.randomUUID(),
            amount: requestData.amount,
            cardNumber: requestData.cardNumber.replace(/\s+/g, ''),
            cardExpMonth: requestData.expirationDate.split('/')[0],
            cardExpYear: `20${requestData.expirationDate.split('/')[1]}`,
            addressLine1: requestData.address1,
            city: requestData.city,
            state: requestData.state,
            postalCode: requestData.postalCode,
            email: requestData.email,
            firstName: requestData.nameOnCard.trim().split(/\s+/)[0],
            lastName: requestData.nameOnCard.trim().split(/\s+/)[1] ? requestData.nameOnCard.trim().split(/\s+/).slice(1).join(" ") : requestData.nameOnCard,
            mobilePhone : requestData.mobileNo.replace(/\D/g, ''),
            referenceId: requestData.sessionId,
            returnURL: requestData.currentUrl,
            browserTimeZone: new Date().getTimezoneOffset(),
            userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : '',
            iPAddress: requestData.ipAddress,
            deviceChannel: 'Browser',
            browserJavascriptEnabled: true,
            browserJavaEnabled: typeof window !== 'undefined' && window.navigator.javaEnabled ? window.navigator.javaEnabled() : false,
            browserLanguage: typeof window !== 'undefined' ? window.navigator.language : '',
            browserColorDepth: typeof window !== 'undefined' && window.screen ? window.screen.colorDepth : 24,
            browserScreenHeight: typeof window !== 'undefined' && window.screen ? window.screen.height : 768,
            browserScreenWidth: typeof window !== 'undefined' && window.screen ? window.screen.width : 1024,
            merchantId: requestData.merchantId
        };


        const response = await fetch(`${CONFIGS.API.THREED_SECURE_CARDINAL_SERVICE}/cardinal/cmpi-lookup`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(postData)
        });
        const data = await response.json();

        if(data && typeof data.parsedResponse !== "undefined"){
            if(typeof data.parsedResponse.ACSUrl !== "undefined" && data.parsedResponse.ACSUrl !== ""){

                if (typeof onOpenModal === 'function') {
                    onOpenModal();
                }

                let stepUpHtml = `<form name="stepup" target="stepupiFrame" id="stepupFrm" method="POST" action="${CONFIGS.API.CARDINAL_SERVICE}/centinelapi/V2/Cruise/StepUp">` +
                '<input type="hidden" name="JWT" value="' + data.token + '" />' +
                '</form>';

                // 2. remove old form
                const existingStepUpForm2 = document.getElementById('stepupFrm');
                if (existingStepUpForm2) {
                    existingStepUpForm2.remove();
                }
                
                // 3. insert html end of body
                document.body.insertAdjacentHTML('beforeend', stepUpHtml);
                
                // 4. Form submit
                setTimeout(() => {
                    const form = document.getElementById('stepupFrm');
                    if (form) {
                        form.submit();
                    }
                }, 300);
                
                // 5. UI toggle 
                const iframeEl = document.getElementById('stepupiFrame');
                
                if (iframeEl) {
                    iframeEl.classList.remove('d-none');
                    iframeEl.classList.add('d-block');
                }
            } else {
                
                let xmlDoc = new DOMParser().parseFromString(data.fullResponse, "text/xml");
                let xidElement = xmlDoc.getElementsByTagName("Xid")[0];
                const xid = xidElement ? xidElement.textContent : "";
                
                return {...data,xid};

            }
        } else {
            
            if (typeof onOpenModal === 'function') {
                onOpenModal();
            }
            
            let stepUpHtml = `<form name="stepup" target="stepupiFrame" id="stepupFrm" method="POST" action="${CONFIGS.API.CARDINAL_SERVICE}/centinelapi/V2/Cruise/StepUp">` +
            '<input type="hidden" name="JWT" value="' + data.token + '" />' +
            '</form>';
            
            // 2. remove old form
            const existingStepUpForm2 = document.getElementById('stepupFrm');
            if (existingStepUpForm2) {
                existingStepUpForm2.remove();
            }
            // 3. insert html end of body
            document.body.insertAdjacentHTML('beforeend', stepUpHtml);
            
            // 4. Form submit
            setTimeout(() => {
                const form = document.getElementById('stepupFrm');
                if (form) {
                    form.submit();
                }
            }, 300);
            
            // 5. UI toggle 
            const iframeEl = document.getElementById('stepupiFrame');
            if (iframeEl) {
                iframeEl.classList.remove('d-none');
                iframeEl.classList.add('d-block');
            }
        }
    } catch (error) {
        // console.log("Error at, send cmpi lookup request",error);
        throw error;
    }
}


export async function  verifyAuthentication (transactionId,merchantId) {
    try {
        const response = await fetch(`${CONFIGS.API.THREED_SECURE_CARDINAL_SERVICE}/cardinal/cmpi-authenticate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ transactionId, merchantId })
        });

        const result = await response.json();      

        if (result.success && result.paresStatus === "Y" && result.cavv !== "") {
            let xmlDoc = new DOMParser().parseFromString(result.fullResponse, "text/xml");
            let xidElement = xmlDoc.getElementsByTagName("Xid")[0];
            let threeDSServerElement = xmlDoc.getElementsByTagName("ThreeDSServerTransactionId")[0];
            const xid = xidElement ? xidElement.textContent : "";
            const threeDSServerTransactionId = threeDSServerElement ? threeDSServerElement.textContent : "";

            return {...result,xid, threeDSServerTransactionId};
        } else if(result.success && result.paresStatus === "N" && result.cavv === ""){
            return {...result, cancle: true };
        } else {
            // console.log("Payment Authentication Failed: " + result.message);
            return result;
        }
    } catch (error) {
        throw error;
    }
};
